import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AppShell from "../../components/AppShell";
import T from "../../components/T";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../../components/ui/accordion";
import { ChevronLeft } from "lucide-react";
import { listPetLessons } from "../../data/pet";

export default function PetProtection() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const lessons = listPetLessons();

  return (
    <AppShell>
      <div className="px-8 pt-16 pb-6" data-testid="page-pets">
        <button onClick={() => navigate("/sanctuary")} className="flex items-center gap-1 text-sm text-foreground/55 hover:text-brand mb-2">
          <ChevronLeft className="w-4 h-4" /> {t("v11.back_to_sanctuary")}
        </button>
        <p className="font-script text-2xl text-brand">{t("v11.pets.kicker")}</p>
        <h1 className="font-serif text-4xl leading-tight"><T i18nKey="v11.pets.h" /></h1>
        <p className="mt-3 text-foreground/70 leading-relaxed">{t("v11.pets.intro")}</p>
      </div>

      <div className="px-8 pb-10">
        <Accordion type="single" collapsible className="rounded-3xl bg-card border border-border px-5">
          {lessons.map((l) => (
            <AccordionItem key={l.slug} value={l.slug} data-testid={`pet-${l.slug}`}>
              <AccordionTrigger className="font-serif text-lg text-left">
                {lang === "es" ? l.title_es : l.title_en}
              </AccordionTrigger>
              <AccordionContent className="text-foreground/80 leading-relaxed space-y-4 pb-2">
                {(lang === "es" ? l.sections_es : l.sections_en).map((s, i) => (
                  <div key={i} className="space-y-2">
                    {s.heading && (
                      <p className="font-serif italic text-foreground/90">{s.heading}</p>
                    )}
                    {s.body && <p>{s.body}</p>}
                    {Array.isArray(s.list) && (
                      <ul className="space-y-1">
                        {s.list.map((it, j) => (
                          <li key={j} className="flex gap-2 text-foreground/85">
                            <span className="text-brand">·</span><span>{it}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </AppShell>
  );
}
